import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    SiGo,
    SiReact,
    SiJavascript,
    SiZig,
    SiCplusplus,
    SiNodedotjs,
    SiPython,
    SiPostgresql,
} from 'react-icons/si';

function Home() {
    const [typedText, setTypedText] = useState('');
    const fullText = 'Full Stack Developer';

    useEffect(() => {
        let index = 0;
        const timer = setInterval(() => {
            if (index <= fullText.length) {
                setTypedText(fullText.slice(0, index));
                index++;
            } else {
                clearInterval(timer);
            }
        }, 100);

        return () => clearInterval(timer);
    }, []);

    const technologies = [
        { name: 'Go', Icon: SiGo, color: '#00ADD8' },
        { name: 'React', Icon: SiReact, color: '#61DAFB' },
        { name: 'JavaScript', Icon: SiJavascript, color: '#F7DF1E' },
        { name: 'Zig', Icon: SiZig, color: '#F7A41D' },
        { name: 'C/C++', Icon: SiCplusplus, color: '#00599C' },
        { name: 'Node.js', Icon: SiNodedotjs, color: '#5FA04E' },
        { name: 'Python', Icon: SiPython, color: '#3776AB' },
        { name: 'PostgreSQL', Icon: SiPostgresql, color: '#4169E1' },
    ];

    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <div className="hero-text">
                        <p className="hero-greeting">Hello, World!</p>
                        <h1 className="hero-title">
                            I'm <span className="highlight">Brandon Cannizzaro</span>
                        </h1>
                        <h2 className="hero-subtitle">
                            <span className="typing-cursor">{typedText}</span>
                            <span className="cursor">|</span>
                        </h2>
                        <p className="hero-description">
                            Computer Science student at NJIT passionate about building 
                            secure applications, breaking them, and exploring new technologies. 
                            Top 5% on Hack The Box Academy.
                        </p>
                        <div className="hero-buttons">
                            <Link to="/projects" className="btn btn-primary">
                                View My Work →
                            </Link>
                            <Link to="/contact" className="btn btn-secondary">
                                Get In Touch
                            </Link>
                        </div>
                    </div>

                    <div className="hero-visual">
                        <div className="code-block">
                            <div className="code-header">
                                <span className="code-dot red"></span>
                                <span className="code-dot yellow"></span>
                                <span className="code-dot green"></span>
                                <span className="code-title">brandon.go</span>
                            </div>
                            <div className="code-content">
                                <div className="code-line">
                                    <span className="line-number">1</span>
                                    <span className="code-text">
                                        <span className="code-keyword">package</span> main
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">2</span>
                                    <span className="code-text"></span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">3</span>
                                    <span className="code-text">
                                        <span className="code-keyword">type</span> Developer <span className="code-keyword">struct</span> {'{'}
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">4</span>
                                    <span className="code-text">
                                        {'    '}Name{'   '}<span className="code-variable">string</span>
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">5</span>
                                    <span className="code-text">
                                        {'    '}Role{'   '}<span className="code-variable">string</span>
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">6</span>
                                    <span className="code-text">
                                        {'    '}Skills []<span className="code-variable">string</span>
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">7</span>
                                    <span className="code-text">{'}'}</span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">8</span>
                                    <span className="code-text"></span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">9</span>
                                    <span className="code-text">
                                        <span className="code-keyword">func</span> <span className="code-function">main</span>() {'{'}
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">10</span>
                                    <span className="code-text">
                                        {'    '}brandon := <span className="code-function">Developer</span>{'{'}
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">11</span>
                                    <span className="code-text">
                                        {'        '}Name:{'   '}<span className="code-string">"Brandon"</span>,
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">12</span>
                                    <span className="code-text">
                                        {'        '}Role:{'   '}<span className="code-string">"Full Stack Dev"</span>,
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">13</span>
                                    <span className="code-text">
                                        {'        '}Skills: []<span className="code-variable">string</span>{'{'}<span className="code-string">"Go"</span>, <span className="code-string">"React"</span>{'}'},
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">14</span>
                                    <span className="code-text">
                                        {'    '}{'}'}
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">15</span>
                                    <span className="code-text">
                                        {'    '}<span className="code-comment">{'// Let\'s build something amazing!'}</span>
                                    </span>
                                </div>
                                <div className="code-line">
                                    <span className="line-number">16</span>
                                    <span className="code-text">{'}'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Tech Stack Section */}
            <section className="tech-section">
                <div className="tech-container">
                    <div className="section-header">
                        <span className="section-label">Technologies</span>
                        <h2 className="section-title">Tools I Work With</h2>
                        <p className="section-description">
                            My current tech stack for building modern applications
                        </p>
                    </div>
                    <div className="tech-grid">
                        {technologies.map((tech) => (
                            <div key={tech.name} className="tech-item">
                                <span className="tech-icon">
                                    <tech.Icon style={{ color: tech.color }} />
                                </span>
                                <span className="tech-name">{tech.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section">
                <div className="section-header">
                    <span className="section-label">Let's Connect</span>
                    <h2 className="section-title">Looking for Opportunities</h2>
                    <p className="section-description">
                        I'm currently seeking software engineering internships and entry-level positions. 
                        If you're looking for a passionate developer, let's talk!
                    </p>
                    <div className="hero-buttons" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                        <Link to="/contact" className="btn btn-primary">
                            Hire Me →
                        </Link>
                        <a 
                            href="https://www.linkedin.com/in/brandon-cannizzaro-3ba8691b9/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="btn btn-outline"
                        >
                            LinkedIn
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Home;
